import { useMemo } from 'react';
import { MenuItem, Select, Typography } from 'seagull';
import { defaultWidth } from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CoverCreditCardFeesSelector(props) {
  const {
    value,
    className,
    vendorBusinessName,
    clientBusinessName,
    testid,
    width = defaultWidth,
    disabled,
    onChange,
    onOpen
  } = props;
  const options = useMemo(() => {
    return [{
      text: clientBusinessName || 'The client',
      value: 'false'
    }, {
      text: vendorBusinessName || 'The service provider',
      value: 'true'
    }];
  }, [vendorBusinessName, clientBusinessName]);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(Typography, {
      children: "Define who will pay the credit card processing fee"
    }), /*#__PURE__*/_jsx(Select, {
      collapseHelperText: false,
      style: {
        marginBlockStart: 8
      },
      value: value,
      testid: testid && "".concat(testid, "-dropdown"),
      width: width,
      disabled: disabled,
      onChange: function (_onChange) {
        function onChange(_x) {
          return _onChange.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange.toString();
        };
        return onChange;
      }(e => onChange(e.target.value === 'true')),
      onClick: onOpen,
      children: options.map((option, idx) => /*#__PURE__*/_jsx(MenuItem, {
        value: option.value,
        "data-testid": testid && "".concat(testid, "-option-").concat(idx),
        children: option.text
      }, option.value))
    })]
  });
}